import React from 'react';
import groceryImage from '../images/Consultantimg.jpg';
import 'bootstrap/dist/css/bootstrap.min.css';

const ProductInquiryPage = () => {
  return (
    <section style={{ backgroundColor: '#4caf50e0', color: 'white', fontFamily: 'sans-serif' }}>
      <div className="container-fluid">
        <div className="row align-items-center min-vh-auto">
          
          {/* Image Section - show after content on mobile */}
          <div className="col-12 col-md-6 order-1 order-md-0 p-0">
            <img
              src={groceryImage}
              alt="Shakambari Grocery"
              className="img-fluid w-100 h-100"
              style={{ objectFit: 'cover', minHeight: '300px' }}
            />
          </div>

          {/* Text Content Section */}
          <div
            className="col-md-6 d-flex flex-column justify-content-center px-4 py-3 order-1 order-md-2 text-start"
            style={{ minHeight: 'auto' }}
          >
            <h1 className="display-5 mb-4 text-start text-md-start">Freshness Delivered Daily</h1>
            <p className="mb-4" style={{ fontSize: '1.1rem', lineHeight: 1.5 }}>
              Welcome to <strong>Shakambari Groceries</strong> – your one-stop destination for fresh and premium quality grocery items.
            </p>

            <ul className="mb-4" style={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
              <li><strong>Fresh Fruits & Vegetables:</strong> Handpicked daily to ensure top quality.</li>
              <li><strong>Organic Staples:</strong> Rice, pulses, millets, flours, and spices directly from trusted farms.</li>
              <li><strong>Dairy & Bakery:</strong> Milk, curd, cheese, bread, and baked goodies always fresh.</li>
            </ul>

            <h5 className="fw-bold">Why Choose Shakambari?</h5>
            <p style={{ fontSize: '1.1rem' }}>
              ✅ Best Prices<br />
              ✅ Trusted Quality<br />
              ✅ Fast Delivery<br />
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductInquiryPage;
